import { Injectable } from '@angular/core'


@Injectable({
  providedIn: 'root'
})
export class LeaveSiteService {
    showPopup = false
    url: string
    onNewPage: boolean = false
}